import { VBaseButton, useButton } from '../VBaseButton';
import { ProgressActivity } from '../asset';
import { joinCn } from '../util';
import { TEXT_BUTTON_SIZE, TEXT_BUTTON_VARIANT } from './constant';
import twStyle from './style';
import type { VTextButtonProps } from './type';

const VTextButton = ({
  children,
  className,
  disabled,
  loading,
  fluid,
  size = TEXT_BUTTON_SIZE.MD,
  variant = TEXT_BUTTON_VARIANT.PRIMARY,
  onClick,
  ...rest
}: React.PropsWithChildren<
  VTextButtonProps & React.ComponentPropsWithRef<'button'>
>) => {
  const { isLoading, handleClick } = useButton({ disabled, loading, onClick });
  const style = twStyle({ fluid, size, variant });

  return (
    <VBaseButton
      className={joinCn(style.textButton, className)}
      disabled={disabled}
      loading={isLoading}
      onClick={handleClick}
      {...rest}
    >
      {isLoading && (
        <ProgressActivity
          aria-label="loading-spinner"
          className="animate-spin"
          role="status"
        />
      )}
      {children}
    </VBaseButton>
  );
};

VTextButton.displayName = 'VTextButton';

export default VTextButton;
